module.exports = __webpack_public_path__ + "static/img/200207.e13c8e02.png";